import { useMutation } from '@apollo/client';
import Alert from '@mui/material/Alert';
import Tooltip from '@mui/material/Tooltip';
import HourglassFullIcon from '@mui/icons-material/HourglassFull';

import ProgressIndicator from '../../../../global/ProgressIndicator';
import { getRegistrantsForCohortQuery_Name } from '../../../../../gql/cohortRegistration/getRegistrantsForCohortQuery';
import { waitlistCohortRegistrationMutation_Gql } from '../../../../../gql/cohortRegistration/waitlistCohortRegistrationMutation';
import { WaitlistCohortRegistrationInput } from '../../../../../models/GeneratedModels';

interface WaitlistIconProps {
  waitlistRegistrationInput: WaitlistCohortRegistrationInput;
}

const WaitlistIcon = ({ waitlistRegistrationInput }: WaitlistIconProps) => {
  const [approveUser, { loading, error }] = useMutation(waitlistCohortRegistrationMutation_Gql, {
    variables: {
      cohortRegistration: waitlistRegistrationInput,
    },
    refetchQueries: [getRegistrantsForCohortQuery_Name],
  });

  const waitlistClick = async () => {
    try {
      await approveUser();
    } catch {}
  };

  return (
    <>
      <ProgressIndicator isOpen={loading} title="Saving" />

      {error && <Alert severity="error">{error.graphQLErrors[0].message}</Alert>}

      <Tooltip title="Waitlist Registrant">
        <HourglassFullIcon onClick={waitlistClick} sx={{ color: '#CCCC00', cursor: 'pointer', mr: 1 }} />
      </Tooltip>
    </>
  );
};

export default WaitlistIcon;
